import { httpQuery } from '@luminovo/data-stack';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { isCustomerRfQDisabled } from '@/shared/permissions/featureFlags';
import type { PageStaticData } from '@/shared/routing';

// The customer's home: `/` sends a customer here, and it forwards to their landing page, which checks its own access.
// The layout above lets in customers only.
export const Route = createFileRoute('/_authenticated/customer-portal/')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: async ({ context: { queryClient } }) => {
        // TODO(MAN-2864 MR 2): forward to the tree's `/customer-portal/start`, `/customer-portal/assemblies` and
        // `/customer-portal/projects` once those routes exist, and only with `customer_portal_routes` on: `/` sends
        // every customer here, so without the flag check the tree would open for tenants that don't have it.
        // Settings that fail to load count as off: the customer lands on the next page down, not on an error.
        const isLandingPageEnabled = await queryClient
            .ensureQueryData(httpQuery('GET /organization-settings/landing-page-settings', {}))
            .then(
                (settings) => settings.enable_landing_page_logged_in,
                () => false,
            );
        if (isLandingPageEnabled) {
            throw redirect({ to: '/start', replace: true });
        }
        throw redirect({ to: isCustomerRfQDisabled() ? '/assemblies' : '/projects', replace: true });
    },
});
